import { useCallback, useRef } from 'react';
import _ from 'lodash';
import { getInvalidSensitiveErrors } from
  '../../ReferralFormFields/MimicReferralGroupValidations/utils';

export default function useSensitiveErrorCheck({
  caseReferrals,
  componentIndex,
  currentUserGroup,
  groupKey,
  referral,
  selectedFields,
  setHasSensitiveErrors,
  suggestedGroups,
}) {
  const hasSensitiveErrorRef = useRef(false);

  const checkSensitiveErrors = useCallback(() => {
    const sensitiveGroups = _.filter(suggestedGroups, (group) => group.sensitive);
    const sensitiveGroupIds = _.map(sensitiveGroups, (g) => g.id);
    const isCurrentUserGroupSensitive = _.get(currentUserGroup, 'sensitive');

    const hasError = selectedFields.some((field) => getInvalidSensitiveErrors({
      caseReferrals,
      sensitiveGroupIds,
      isCurrentUserGroupSensitive,
      fields: selectedFields,
      groupId: field[groupKey].value.id,
      referral,
    }).length > 0);

    if (hasError !== hasSensitiveErrorRef.current) {
      hasSensitiveErrorRef.current = hasError;
      if (setHasSensitiveErrors) {
        setHasSensitiveErrors(hasError, componentIndex);
      }
    }

    return hasError;
  }, [caseReferrals, componentIndex, currentUserGroup, groupKey, referral,
    selectedFields, setHasSensitiveErrors, suggestedGroups]);

  return checkSensitiveErrors;
}
